import React from 'react'
import { Grid } from '@material-ui/core'
import { Bar } from 'react-chartjs-2'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'

import * as Utils from 'src/utils/chartsUtils'
import { useStyles } from '../styles'
import TableAAPP from '../../Tables/TableAAPP'

const MEIMarketRegionsCard = props => {
  const { selectedDate, meiMarketRegions, gAMeiMarketRegions, gBMeiMarketRegions } = props
  const classes = useStyles()
  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Mercado MEI Runt total por zonas</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={12}>
            <TableAAPP array={meiMarketRegions} selectedDate={selectedDate} param="TERRITORIO" colParam AA />
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <h3>Mix por zonas - años</h3>
            <br />
            <Bar
              data={Utils.customBarLineDataGroup(gAMeiMarketRegions, 'territorio', 'PORCENTAJE', 'y', '100')}
              options={Utils.optionsGroupedCharts}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <h3>Mix por zonas - mes</h3>
            <br />
            <Bar
              data={Utils.customBarLineDataGroup(gBMeiMarketRegions, 'TERRITORIO', 'PORCENTAJE', 'MESC', '100')}
              options={Utils.optionsGroupedCharts}
            />
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default MEIMarketRegionsCard
